import React from "react";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";
import { HelpCircle } from "lucide-react";
import { Button, Tooltip } from "@mui/material";

const DocsWidget = ({ docsRoute, styles = {} }) => {
  const docsUrl = `https://docs.vodex.ai${docsRoute}`;

  return (
    <Tooltip title="Help & Documention" arrow placement="bottom">
      <Button
        onClick={() => window.open(docsUrl, "_blank")}
        sx={{
          ...commonStyles.favBtn,
          borderColor: "#2196F3",
          backgroundColor: "rgba(33, 150, 243, 0.04)",
          "&:hover": {
            borderColor: "#1976D2",
            backgroundColor: "rgba(33, 150, 243, 0.08)",
          },

          ...styles,
        }}
        variant="outlined"
      >
        <HelpCircle size={18} color="#6366F1" strokeWidth={1.5} />
      </Button>
    </Tooltip>
  );
};

export default DocsWidget;
